import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import BurpsuiteEnterpriseConfigListing from './BurpsuiteEnterpriseConfigListing'
import BurpsuiteEnterpriseCredentialsForm from './BurpsuiteEnterpriseCredentialsForm'

export default function BurpsuiteEnterprisePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={BurpsuiteEnterpriseCredentialsForm}
            PullConfigListingView={BurpsuiteEnterpriseConfigListing}
        />
    )
}